export const TOGGLE_SELF_ASSESSED_STATUS_FOR_STANDARD = /* GraphQL */ `
  mutation ToggleSelfAssessedStatusForStandard($studentId: String!, $standardExternalId: String!, $selfAssessed: Boolean!) {
    toggleSelfAssessedStatusForStandard(studentId: $studentId, standardExternalId: $standardExternalId, selfAssessed: $selfAssessed) {
      selfAssessedStatus
	  }
  }
`;
